export default {
    'diagram5-5c': {
      'title': `Please drag and drop the elements of the problem definition into their correct positions in the framework`,
      'exercise-title': 'HOUSTON INFORMATION SYSTEMS GROUP - PROBLEM',
      'structure-answers-title': `Elements of the problem definition`,
      'situation-title': 'situation',
      'diagram-header': 'ISG',
      'left-box': 'Systems design/ development',
      'middle-box': 'NW design/ development',
      'right-box': 'Systems integration',
      'bottom-box-points': `
      <ul>
        <li>Has good project management skills, technical expertise</li>
      </ul>
      `,
      'situation-desc': 'DISTURBING EVENT',
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/5/5c/diagram5/i18n/en.js